import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { IScheduleOrderFOB } from "interfaces/order-fob";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_SCHEDULED_ORDER_FOB_" }
);

export interface FetchScheduledOrderFOBState extends IState {
  data: IScheduleOrderFOB | null;
}

export interface FetchScheduledOrderFOBSuccess extends ISuccessAction {
  data: IScheduleOrderFOB;
}

const INITIAL_STATE: FetchScheduledOrderFOBState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchScheduledOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchScheduledOrderFOBState, action: FetchScheduledOrderFOBSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchScheduledOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchScheduledOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchScheduledOrderFOBTypes = Types;
export const FetchScheduledOrderFOBActions = Creators;
